<div class="ad-header-default">
  <div class="ad-header-left">
    <img class="ad-header-left-logo" *ngIf="logoUrl" (click)="clickLogo($event)"
      [style.height.px]="options.logoHeight || null" [attr.src]="logoUrl" alt="" />
  </div>
  <div class="ad-header-right">
    <div class="ad-header-tool-wrapper" *ngIf="rightToolTemplate">
      <div *ngTemplateOutlet="rightToolTemplate"></div>
    </div>

    <div class="ad-header-all-portfolio" *ngIf="options.showAllPortfolioLink" (click)="viewAllPortfolios($event);">
      View All Portfolios
    </div>
    <div class="ad-header-right-user">
      <div class="ad-header-right-user-name">
        {{ name }}
      </div>
      <div class="ad-header-right-user-arrow"><i class="fa fa-chevron-up"></i></div>
      <div class="ad-header-right-user-menus">
        <div class="ad-header-right-user-menu" *ngFor="let menu of menus" (click)="clickMenu($event, menu)">
          <span>
            {{ menu.text }}
          </span>
        </div>
      </div>
    </div>
      <ng-content>
      </ng-content>
  </div>
</div>
